import { render, staticRenderFns } from "./DistributorSync.vue?vue&type=template&id=192bbc76&scoped=true&"
import script from "./DistributorSync.vue?vue&type=script&lang=js&"
export * from "./DistributorSync.vue?vue&type=script&lang=js&"
import style0 from "./DistributorSync.vue?vue&type=style&index=0&id=192bbc76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192bbc76",
  null
  
)

export default component.exports